import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Settings from '../../Settings/Settings'

export default function DeleteImageDialog(props) {

  const componentConstants = {
    ...props.componentConstants
  }

  const componentMethods = {
      ...props.componentMethods
  }

  const handleClose = () => {
    props.setOpenDeleteDialog(false);
  };
  const getShoppingCartTotal = () => {
      let accountToken = ''
      if(componentMethods.getLocalStorage('user')) {
          accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash;
      }
      componentMethods.ajax(Settings.API_URL + Settings.API_ENDPOINT_SHOPPINGCART_TOTAL + componentMethods.getLocalStorage('shoppingCart').shoppingCartSha + accountToken, {},'GET','addresses', (data) => {
          componentMethods.setManagerState({shoppingCartTotal: data.items.total})
      })
  }
  const deleteShoppingCartItemAction = () => {
    let url = Settings.API_URL + Settings.API_ENDPOINT_SHOPPINGCARTITEMS + componentMethods.getLocalStorage('shoppingCart').shoppingCartSha + '/' + props.element.shoppingCartItemsID
    let accountToken = ''
    if(componentMethods.getLocalStorage('user') && componentMethods.getLocalStorage('user').tokensHash) {
        accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash
    }

    componentMethods.setManagerState({loadingShoppingCartItems: true, shoppingCartItems: []}, () => {
        componentMethods.ajax(url += accountToken, 
            {}, 
           "DELETE", 'shoppingCartItems', 
            (data) => {
               componentMethods.getShoppingCartItemsAction()
               getShoppingCartTotal()
           })
    })
}
  return (
    <div>
      <Dialog
        open={props.openDeleteDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{componentConstants.language.LANG_DELETE_SHOPPINGCARTITEM_MESSAGE_TITLE}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {componentConstants.language.LANG_DELETE_SHOPPINGCARTITEM_MESSAGE}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
          {componentConstants.language.LANG_CANCEL}
          </Button>
          <Button onClick={(e) => {deleteShoppingCartItemAction(); handleClose()}} color="secondary" variant="contained" autoFocus>
          {componentConstants.language.LANG_DELETE}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}